import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34415c7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"white-space":"normal"} }, "¿Eres el mítico Narsil?", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 2 }

import {
  Clasificacion,
  Emparejamiento,
  GenerarRonda,
  JugadorParaEmparejamiento,
} from "@/interfaces/Live";
import {
  InscripcionTorneoCreadoMasDTO,
  TorneoGestionInfoMasDTO,
} from "@/interfaces/Torneo";
import { generarRonda } from "@/services/PartidaTorneoService";
import { ref, watch, onMounted, computed } from "vue";
import { getPartidasTorneo } from "@/services/TorneosService";
import { emparejarSinRepetir } from "@/utils/emparejamientoSinRepetir";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";

const MENSAJE_ERROR_GENERAL =
  "No se ha podido generar la ronda. Inténtalo de nuevo y si el error persiste contacta con el administrador.";
const MENSAJE_ERROR_SIN_REPETIR =
  "No se ha podido generar la ronda sin repetir emparejamientos. Prueba a permitir que se repitan.";

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalParametrosRondasMas',
  props: {
    isVisible: { type: Boolean },
    torneo: {},
    clasificacion: {},
    clasificacionDividida: {},
    ronda: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const internalIsVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const mismaComunidadCheck = ref<boolean>(false);
const goodVsEvilCheck = ref<boolean>(false);
const isTorneoNarsil = ref<string>("NO");

const goodVsEvilCheckString = ref<string>("NO");
const retosCheck = ref<boolean>(false);
const esEloCheck = ref<boolean>(false);
// Por defecto sin repetir rival, lo normal en un suizo; si no hay forma de emparejar sin repetir, la ventana lo avisa
const esRepetirRivalCheck = ref<string>("NO");
const opcionImpares = ref<string | null>(null);
const isImpares = ref<boolean>(false);
const numeroRonda = ref<number>();
const jugadoresObj = ref<InscripcionTorneoCreadoMasDTO[]>();
const jugadoresNick = ref<JugadorParaEmparejamiento[]>();
const jugador1 = ref<JugadorParaEmparejamiento>();
const jugador2 = ref<JugadorParaEmparejamiento>();
const rondas = ref<number[]>();
const isGenerating = ref<boolean>(false);
const torneoSelected = ref<TorneoGestionInfoMasDTO>();
const clasificacionDividida = ref<Clasificacion[]>([]);
const clasificacionZona1 = ref<Clasificacion[]>([]);
const clasificacionZona2 = ref<Clasificacion[]>([]);
const errorRonda = ref<string | null>(null);
const showErrorModal = ref<boolean>(false);
const mensajeError = ref<string>(MENSAJE_ERROR_GENERAL);
const showSuccessModal = ref<boolean>(false);
const emparejamientos = ref<
  { jugador1: JugadorParaEmparejamiento; jugador2: JugadorParaEmparejamiento }[]
>([]);
const isAddEmparejamientoEnabled = computed(() => {
  return jugador1.value && jugador2.value && jugador1.value !== jugador2.value;
});

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

watch(numeroRonda, (newValue) => {
  if (newValue) {
    errorRonda.value = null;
  }
});

onMounted(async () => {
  torneoSelected.value = props.torneo;

  // Si hay inscripciones, procesar jugadores
  if (torneoSelected.value?.inscripciones) {
    jugadoresObj.value = torneoSelected.value.inscripciones;
    isImpares.value = jugadoresObj.value?.length % 2 !== 0;

    // Usamos `for...of` para manejar promesas de manera secuencial o `map` con `Promise.all`
    jugadoresNick.value = torneoSelected.value?.inscripciones.map(
      (element) => ({
        idUsuario: element.idUsuario,
        nick: element.nick,
      })
    );
  }

  // Procesar rondas si existe el número de partidas
  if (torneoSelected.value?.torneo?.numeroPartidas) {
    const totalRondas = torneoSelected.value.torneo.numeroPartidas;
    rondas.value = Array.from({ length: totalRondas }, (_, i) => i + 1);
  }
});

const addEmparejamiento = () => {
  //Validaciones

  if (!jugador1.value || !jugador2.value) {
    alert("No puedes dejar a los jugadores en blanco");
    return;
  }

  if (jugador1.value.idUsuario === jugador2.value.idUsuario) {
    alert("No puedes emparejar al mismo jugador.");
    return;
  }

  const isJugador1InEmparejamientos: boolean = emparejamientos.value.some(
    (emparejamiento) =>
      emparejamiento.jugador1.idUsuario === jugador1.value!.idUsuario ||
      emparejamiento.jugador2.idUsuario === jugador1.value!.idUsuario
  );
  const isJugador2InEmparejamientos: boolean = emparejamientos.value.some(
    (emparejamiento) =>
      emparejamiento.jugador1.idUsuario === jugador2.value!.idUsuario ||
      emparejamiento.jugador2.idUsuario === jugador2.value!.idUsuario
  );

  if (isJugador1InEmparejamientos || isJugador2InEmparejamientos) {
    alert("Uno o ambos jugadores ya están emparejados.");
    return;
  }

  const emparejamientoTerminado: Emparejamiento = {
    jugador1: jugador1.value,
    jugador2: jugador2.value,
  };
  emparejamientos.value.push(emparejamientoTerminado);

  jugador1.value = undefined;
  jugador2.value = undefined;
};

const dividirClasificacionEnZonas = () => {
  clasificacionDividida.value = props.clasificacionDividida;
  const totalJugadores: number = clasificacionDividida.value.length;
  const esImpar: boolean = totalJugadores % 2 !== 0;

  const mitad: number = Math.floor(totalJugadores / 2);

  var zona1Size: number = esImpar ? mitad + 1 : mitad;
  if (zona1Size % 2 !== 0) zona1Size = zona1Size + 1;

  clasificacionZona1.value = clasificacionDividida.value.slice(0, zona1Size);
  clasificacionZona2.value = clasificacionDividida.value.slice(zona1Size);
};

const generarEmparejamientos = (
  clasificacion: Clasificacion[]
): Emparejamiento[] => {
  const emparejamientos: Emparejamiento[] = [];

  if (props.torneo?.torneo.idTorneo == 7 && props.ronda > 2) {
    dividirClasificacionEnZonas();
    const zona1 = clasificacionZona1.value;
    const zona2 = clasificacionZona2.value;

    // Emparejar a los jugadores de zona 1
    const jugadoresZona1 = props.clasificacion.filter((jugador) =>
      zona1.some((z) => z.idUsuario === jugador.idUsuario)
    );

    for (let i = 0; i < jugadoresZona1.length; i += 2) {
      if (i + 1 < jugadoresZona1.length) {
        const jugador1 = jugadoresZona1[i];
        const jugador2 = jugadoresZona1[i + 1];

        emparejamientos.push({
          jugador1: { idUsuario: jugador1.idUsuario, nick: jugador1.nick },
          jugador2: { idUsuario: jugador2.idUsuario, nick: jugador2.nick },
        });
      }
    }

    // Emparejar a los jugadores de zona 2
    const jugadoresZona2 = props.clasificacion.filter((jugador) =>
      zona2.some((z) => z.idUsuario === jugador.idUsuario)
    );

    for (let i = 0; i < jugadoresZona2.length; i += 2) {
      if (i + 1 < jugadoresZona2.length) {
        const jugador1 = jugadoresZona2[i];
        const jugador2 = jugadoresZona2[i + 1];

        emparejamientos.push({
          jugador1: { idUsuario: jugador1.idUsuario, nick: jugador1.nick },
          jugador2: { idUsuario: jugador2.idUsuario, nick: jugador2.nick },
        });
      }
    }
  } else {
    // Emparejar en formato suizo
    for (let i = 0; i < clasificacion.length; i += 2) {
      if (i + 1 < clasificacion.length) {
        const jugador1 = clasificacion[i];
        const jugador2 = clasificacion[i + 1];

        emparejamientos.push({
          jugador1: { idUsuario: jugador1.idUsuario, nick: jugador1.nick },
          jugador2: { idUsuario: jugador2.idUsuario, nick: jugador2.nick },
        });
      }
    }
  }

  return emparejamientos;
};

const generarEmparejamientosLuzVsOscuridad = (
  clasificacion: Clasificacion[]
): Emparejamiento[] => {
  const emparejamientos: Emparejamiento[] = [];

  // Si es por zonas Hardcode domadores
  if (props.torneo?.torneo.idTorneo == 7 && props.ronda > 2) {
    dividirClasificacionEnZonas();
    const zona1 = clasificacionZona1.value;
    const zona2 = clasificacionZona2.value;

    // Emparejar a los jugadores de zona 1
    const jugadoresZona1 = props.clasificacion.filter((jugador) =>
      zona1.some((z) => z.idUsuario === jugador.idUsuario)
    );

    for (let i = 0; i < jugadoresZona1.length; i += 2) {
      if (i + 1 < jugadoresZona1.length) {
        const jugador1 = jugadoresZona1[i];
        const jugador2 = jugadoresZona1[i + 1];

        emparejamientos.push({
          jugador1: { idUsuario: jugador1.idUsuario, nick: jugador1.nick },
          jugador2: { idUsuario: jugador2.idUsuario, nick: jugador2.nick },
        });
      }
    }

    // Emparejar a los jugadores de zona 2
    const jugadoresZona2 = props.clasificacion.filter((jugador) =>
      zona2.some((z) => z.idUsuario === jugador.idUsuario)
    );

    for (let i = 0; i < jugadoresZona2.length; i += 2) {
      if (i + 1 < jugadoresZona2.length) {
        const jugador1 = jugadoresZona2[i];
        const jugador2 = jugadoresZona2[i + 1];

        emparejamientos.push({
          jugador1: { idUsuario: jugador1.idUsuario, nick: jugador1.nick },
          jugador2: { idUsuario: jugador2.idUsuario, nick: jugador2.nick },
        });
      }
    }
  } else {
    // Emparejar en formato suizo luz vs osc
    var clasificacionLuz: Clasificacion[] = [];
    var clasificacionOsc: Clasificacion[] = [];

    clasificacion.forEach((element) => {
      if (element.bando == "evil") clasificacionOsc.push(element);
      else clasificacionLuz.push(element);
    });

    do {
      const jugador1 = clasificacionLuz[0];
      const jugador2 = clasificacionOsc[0];
      emparejamientos.push({
        jugador1: { idUsuario: jugador1.idUsuario, nick: jugador1.nick },
        jugador2: { idUsuario: jugador2.idUsuario, nick: jugador2.nick },
      });

      clasificacionLuz.shift();
      clasificacionOsc.shift();

      clasificacion = clasificacion.filter(
        (element) =>
          element.idUsuario !== jugador1.idUsuario &&
          element.idUsuario !== jugador2.idUsuario
      );
    } while (clasificacionLuz.length > 0 && clasificacionOsc.length > 0);

    if (clasificacion.length > 1) {
      do {
        const jugador1 = clasificacion[0];
        const jugador2 = clasificacion[1];
        emparejamientos.push({
          jugador1: { idUsuario: jugador1.idUsuario, nick: jugador1.nick },
          jugador2: { idUsuario: jugador2.idUsuario, nick: jugador2.nick },
        });

        clasificacion.shift();
        clasificacion.shift();
      } while (clasificacion.length > 1);
    }
  }

  return emparejamientos;
};

// Sin repetir ningún emparejamiento de las rondas anteriores, bye incluido
const generarEmparejamientosSinRepetir = (
  clasificacion: Clasificacion[],
  partidasAnteriores: PartidaTorneoDTO[],
  luzVsOscuridad: boolean
): Emparejamiento[] | null => {
  // Hardcode para domadores: cada zona por separado
  if (props.torneo?.torneo.idTorneo == 7 && props.ronda > 2) {
    dividirClasificacionEnZonas();
    const emparejamientos: Emparejamiento[] = [];
    for (const zona of [clasificacionZona1.value, clasificacionZona2.value]) {
      const jugadoresZona = props.clasificacion.filter((jugador) =>
        zona.some((z) => z.idUsuario === jugador.idUsuario)
      );
      const emparejamientosZona = emparejarSinRepetir(
        jugadoresZona,
        partidasAnteriores
      );
      if (!emparejamientosZona) return null;
      emparejamientos.push(...emparejamientosZona);
    }
    return emparejamientos;
  }

  return emparejarSinRepetir(clasificacion, partidasAnteriores, luzVsOscuridad);
};

// Partidas de todas las rondas anteriores: así no se repite ningún emparejamiento en todo el torneo
const getPartidasRondasAnteriores = async (
  idTorneo: number
): Promise<PartidaTorneoDTO[]> => {
  const response = await getPartidasTorneo(idTorneo);
  return (response.data as PartidaTorneoDTO[]).filter(
    (partida) => partida.numeroRonda < props.ronda
  );
};

const confirmarConfiguracion = async () => {
  mensajeError.value = MENSAJE_ERROR_GENERAL;
  numeroRonda.value = props.ronda;
  if (!numeroRonda.value) {
    errorRonda.value = "El número de ronda es obligatorio.";
    return;
  }
  if (!props.torneo?.torneo.idTorneo) {
    console.error("El idTorneo no está definido");
    return;
  }

  let isNarsil = false;
  if (isTorneoNarsil.value === "SI") {
    isNarsil = true;
    mismaComunidadCheck.value = false;
    goodVsEvilCheck.value = false;
  }

  if (goodVsEvilCheckString.value === "SI") goodVsEvilCheck.value = true;
  else goodVsEvilCheck.value = false;

  // Guerra civil
  if (!goodVsEvilCheck.value) {
    //Si no se puede repetir el rival
    if (esRepetirRivalCheck.value == "NO" && !isNarsil) {
      errorRonda.value = null;

      const emparejamientosGenerados = generarEmparejamientosSinRepetir(
        props.clasificacion,
        await getPartidasRondasAnteriores(props.torneo.torneo.idTorneo),
        false
      );
      // Sin forma de emparejar a todos sin repetir: mejor no generar la ronda
      if (!emparejamientosGenerados) {
        mensajeError.value = MENSAJE_ERROR_SIN_REPETIR;
        showErrorModal.value = true;
        return;
      }

      const configuracion: GenerarRonda = {
        mismaComunidadCheck: mismaComunidadCheck.value,
        luzVsOscCheck: goodVsEvilCheck.value,
        retosCheck: retosCheck.value,
        emparejamientos: emparejamientosGenerados,
        esEloCheck: esEloCheck.value,
        opcionImpares: opcionImpares.value,
        idTorneo: props.torneo?.torneo.idTorneo,
        idRonda: numeroRonda.value,
        isTorneoNarsil: isNarsil,
      };

      try {
        isGenerating.value = true;
        await generarRonda(configuracion);
        showSuccessModal.value = true;
      } catch (error) {
        showErrorModal.value = true;
        console.error(error);
      } finally {
        isGenerating.value = false;
      }

      // Como en el resto de casos: se cierra y la gestión recarga las rondas. Sin esto la ventana seguía abierta con la
      // ronda ya creada y, al volver a pulsar, se generaba otra vez
      emit("confirm", configuracion);
      closeModal();
    }
    //Si se puede repetir rival
    else {
      errorRonda.value = null;

      const emparejamientosGenerados: Emparejamiento[] = generarEmparejamientos(
        props.clasificacion
      );

      const configuracion: GenerarRonda = {
        mismaComunidadCheck: mismaComunidadCheck.value,
        luzVsOscCheck: goodVsEvilCheck.value,
        retosCheck: retosCheck.value,
        emparejamientos: emparejamientosGenerados,
        esEloCheck: esEloCheck.value,
        opcionImpares: opcionImpares.value,
        idTorneo: props.torneo?.torneo.idTorneo,
        idRonda: numeroRonda.value,
        isTorneoNarsil: isNarsil,
      };

      try {
        isGenerating.value = true;
        await generarRonda(configuracion);
        showSuccessModal.value = true;
      } catch (error) {
        showErrorModal.value = true;
        console.error(error);
      } finally {
        isGenerating.value = false;
      }

      emit("confirm", configuracion);
      closeModal();
    }
  }
  // luz vs oscuridad
  else {
    //Si no se puede repetir el rival

    if (esRepetirRivalCheck.value == "NO" && !isNarsil) {
      errorRonda.value = null;

      const emparejamientosGenerados = generarEmparejamientosSinRepetir(
        props.clasificacion,
        await getPartidasRondasAnteriores(props.torneo.torneo.idTorneo),
        true
      );
      // Sin forma de emparejar a todos sin repetir: mejor no generar la ronda
      if (!emparejamientosGenerados) {
        mensajeError.value = MENSAJE_ERROR_SIN_REPETIR;
        showErrorModal.value = true;
        return;
      }

      const configuracion: GenerarRonda = {
        mismaComunidadCheck: mismaComunidadCheck.value,
        luzVsOscCheck: goodVsEvilCheck.value,
        retosCheck: retosCheck.value,
        emparejamientos: emparejamientosGenerados,
        esEloCheck: esEloCheck.value,
        opcionImpares: opcionImpares.value,
        idTorneo: props.torneo?.torneo.idTorneo,
        idRonda: numeroRonda.value,
        isTorneoNarsil: isNarsil,
      };

      try {
        isGenerating.value = true;
        await generarRonda(configuracion);
        showSuccessModal.value = true;
      } catch (error) {
        showErrorModal.value = true;
        console.error(error);
      } finally {
        isGenerating.value = false;
      }

      emit("confirm", configuracion);
      closeModal();
    }
    //Si se puede repetir rival
    else {
      errorRonda.value = null;

      const emparejamientosGenerados: Emparejamiento[] =
        generarEmparejamientosLuzVsOscuridad(props.clasificacion);

      const configuracion: GenerarRonda = {
        mismaComunidadCheck: mismaComunidadCheck.value,
        luzVsOscCheck: goodVsEvilCheck.value,
        retosCheck: retosCheck.value,
        emparejamientos: emparejamientosGenerados,
        esEloCheck: esEloCheck.value,
        opcionImpares: opcionImpares.value,
        idTorneo: props.torneo?.torneo.idTorneo,
        idRonda: numeroRonda.value,
        isTorneoNarsil: isNarsil,
      };

      try {
        isGenerating.value = true;
        await generarRonda(configuracion);
        showSuccessModal.value = true;
      } catch (error) {
        showErrorModal.value = true;
        console.error(error);
      } finally {
        isGenerating.value = false;
      }

      emit("confirm", configuracion);
      closeModal();
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Configurar Ronda " + _toDisplayString(props.ronda), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                      modelValue: isTorneoNarsil.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isTorneoNarsil).value = $event)),
                      class: "text-wrap"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_1
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "Sí",
                          value: "SI"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "No",
                          value: "NO"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (isTorneoNarsil.value === 'NO')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_v_radio_group, {
                            inline: "",
                            modelValue: goodVsEvilCheckString.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((goodVsEvilCheckString).value = $event)),
                            label: "¿Prevalece luz vs oscuridad?"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "SI",
                                value: "SI"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "NO",
                                value: "NO"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_radio_group, {
                            inline: "",
                            modelValue: esRepetirRivalCheck.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((esRepetirRivalCheck).value = $event)),
                            label: "¿Se pueden repetir emparejamientos?"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "SI",
                                value: "SI"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "NO",
                                value: "NO"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (isImpares.value)
                      ? (_openBlock(), _createBlock(_component_v_radio_group, {
                          key: 1,
                          modelValue: opcionImpares.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((opcionImpares).value = $event)),
                          label: "Los jugadores son impares. ¿Cómo quieres gestionarlo?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: "Hacer un bye",
                              value: "bye"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (retosCheck.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_v_combobox, {
                            modelValue: jugador1.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((jugador1).value = $event)),
                            items: jugadoresNick.value,
                            "item-title": "nick",
                            "item-value": "idUsuario",
                            label: "Jugador 1"
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_combobox, {
                            modelValue: jugador2.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((jugador2).value = $event)),
                            items: jugadoresNick.value,
                            "item-title": "nick",
                            "item-value": "idUsuario",
                            label: "Jugador 2"
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_btn, {
                            disabled: !isAddEmparejamientoEnabled.value,
                            variant: "tonal",
                            color: "blue",
                            onClick: addEmparejamiento
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Agregar Emparejamiento")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "ga-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      disabled: isGenerating.value,
                      onClick: confirmarConfiguracion,
                      color: "primary",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Generar ronda")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "secondary",
                      onClick: closeModal,
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelar")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Ronda generada correctamente.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: mensajeError.value,
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible", "message"])
  ], 64))
}
}

})